import { Component, Input } from '@angular/core';
import { ApplicationPathConstants } from '@ddt-web/config';
import { StringUtil } from '@ddt-web/generic-utils';

@Component({
	selector: 'mb-redirect-cta',
	templateUrl: './redirect-cta.component.html',
	styleUrls: ['./redirect-cta.component.scss']
})
export class RedirectCtaComponent {

	@Input() public redirectPath: string = '';
	@Input() public familyId: string = '';
	@Input() public pathName: string = '';

	public onRedirectClick(): void {
		const url = ApplicationPathConstants.ACT2_PATHS[this.redirectPath];
		const replacedFamilyId = StringUtil.replaceAll(url, '$$familyId$$', this.familyId);
		const finalUrl = StringUtil.replaceAll(replacedFamilyId, '$$pathName$$', this.pathName);
		window.open(finalUrl, '_self');
	}
}
